module.exports = __webpack_public_path__ + "static/media/barChart.e2def1a8.svg";